import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { Answers } from '../models/answers.model';
import { Product } from '../models/data.model';
import { Answer, Step } from '../models/qa.model';
import { StartupService } from './startup.service';
import { WoodConditionImage } from '../models/wood-condition-image.model';

@Injectable()
export class WoodConditionImageService {
  
  constructor(private http: HttpClient, private startupService: StartupService) {
  }

  getWoodCondition(): Promise<WoodConditionImage[]> {
    return this.http.get<WoodConditionImage>(`${environment.apiUrl}/woodConditionImage/${this.startupService.websiteName}`)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error')).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/wood-condition.service.ts